import React, { useEffect, useState } from 'react';
import DataTable from '../../components/DataTablePtBr';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/Header';
import api from '../../services/api';
import { showError, showSuccess, showConfirmation } from '../../services/alert';

const ColheitaList = () => {
  const [colheitas, setColheitas] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const fetchColheitas = async () => {
    setLoading(true);
    try {
      const res = await api.get('/colheita');
      setColheitas(res.data);
    } catch (err) {
      console.error('Erro ao buscar colheitas:', err);
      showError('Erro ao buscar colheitas.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchColheitas();
  }, []);

  const handleDelete = async (id) => {
    const confirmou = await showConfirmation({
      title: 'Excluir colheita?',
      text: 'Essa ação não pode ser desfeita.',
      confirmText: 'Sim, excluir',
      cancelText: 'Cancelar',
    });
    if (!confirmou) return;

    try {
      await api.delete(`/colheita/${id}`);
      showSuccess('Colheita excluída com sucesso.');
      fetchColheitas();
    } catch (err) {
      console.error('Erro ao excluir colheita:', err);
      showError('Erro ao excluir colheita.');
    }
  };

  const columns = [
    { name: 'Safra', selector: row => row.safraNome, sortable: true },
    { name: 'Talhão', selector: row => row.talhaoNome || '-', sortable: true },
    { name: 'Produto', selector: row => row.produtoColhido || '-', sortable: true },
    { name: 'Data', selector: row => new Date(row.data).toLocaleDateString(), sortable: true },
    { name: 'Quantidade', selector: row => `${Number(row.quantidade || 0).toLocaleString('pt-BR')} ${row.unidade}`, sortable: true },
    { name: 'Prod./ha', selector: row => Number(row.produtividadePorHectare || 0).toLocaleString('pt-BR'), sortable: true },
    { name: 'Armazém', selector: row => row.armazem || '-', sortable: true },
    { name: 'Unidade', selector: row => row.unidade, sortable: true },
    {
      name: 'Ações',
      cell: row => (
        <div className="d-flex gap-1">
          <button
            className="btn btn-outline-success btn-sm"
            onClick={() => navigate(`/colheitas/editar/${row.id}`)}
          >
            <i className="bi bi-pencil-square"></i> Editar
          </button>
          <button
            className="btn btn-outline-danger btn-sm"
            onClick={() => handleDelete(row.id)}
          >
            <i className="bi bi-trash"></i> Excluir
          </button>
        </div>
      ),
      ignoreRowClick: true,
    },
  ];

  return (
    <div className="container mt-4">
      <Header />
      <div className="card shadow-lg border-0 rounded-3">
        <div className="card-header bg-success text-white d-flex justify-content-between align-items-center rounded-top-3">
          <div className="d-flex align-items-center gap-3">
            <button
              className="btn btn-light btn-sm d-flex align-items-center gap-1"
              onClick={() => navigate('/menu')}
              disabled={loading}
            >
              <i className="bi bi-arrow-left text-success"></i>
              <span className="text-success fw-semibold">Voltar</span>
            </button>
            <div>
              <h5 className="mb-0">Colheitas</h5>
              <small className="text-white-50">Gerencie as colheitas registradas nas safras</small>
            </div>
          </div>
          <button
            className="btn btn-light text-success fw-bold"
            onClick={() => navigate('/colheitas/create')}
          >
            <i className="bi bi-plus-circle"></i> Nova Colheita
          </button>
        </div>
        <div className="card-body">
          <DataTable
            columns={columns}
            data={colheitas}
            pagination
            responsive
            highlightOnHover
            striped
            progressPending={loading}
            noDataComponent={<div className="text-muted">Nenhuma colheita encontrada.</div>}
          />
        </div>
      </div>
    </div>
  );
};

export default ColheitaList;
